import FooterTop from 'Components/FooterTop/FooterTop';
import Expertise, { ExpertiseIntro } from 'Components/Home/Expertise';
import AboutUs from 'Components/Home/AboutUs';
// import Bess from 'Components/Home/Bess';
// import Expanding from 'Components/Home/Expanding';
import Footer from 'Components/Home/Footer';
import Hero from 'Components/Home/Hero';
import Navbar from 'Components/Home/Navbar';
import React from 'react';
import Stratgeic from 'Components/Home/Stratgeic';

export default function HomePage() {
  return (
    <div>
      <Navbar />
      <Hero />
      {/* <Energymangment /> */}
      {/* <Bess /> */}
      <ExpertiseIntro />
      <div className="additional-bg">
        <Expertise />
        <AboutUs />
      </div>
      <Stratgeic />
      <div className=" relative ">
        {/* <Expanding /> */}
        <FooterTop />
        <Footer />
      </div>
    </div>
  );
}
